// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"5f5ecfc8","312":"43d9b921"}[chunkId] + ".chunk.js";
};